/**
 * HeroAnimation
 */

/**
 * @return {void}
 */
function HeroAnimation_init() {
    if (window.bodymovin) {
        const animation = document.querySelector('[data-component="ProductPageHero_Animation"]');

        if (animation instanceof HTMLElement) {
            window.bodymovin.loadAnimation({
                container: animation,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: animation.getAttribute("data-jsonanimation"),
            });
        }
    }
}

/**
 * ProductOverviewAnimation
 */

/**
 * @return {void}
 */
function ProductOverviewAnimation_Background_play() {
    document.querySelector('[data-component="ProductOverviewAnimation_Background"]').classList.remove('product-overview-animation-background-turn');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Center_play() {
    document.querySelector('[data-component="ProductOverviewAnimation_Center"]').classList.remove('product-overview-animation-center');
}

// Texts

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Yellow_activate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Yellow"]');
    text.style.opacity = "1";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Yellow_deactivate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Yellow"]');
    text.style.opacity = "0";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Red_activate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Red"]');
    text.style.opacity = "1";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Red_deactivate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Red"]');
    text.style.opacity = "0";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Blue_activate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Blue"]');
    text.style.opacity = "1";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Blue_deactivate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Blue"]');
    text.style.opacity = "0";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Purple_activate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Purple"]');
    text.style.opacity = "1";
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Text_Purple_deactivate() {
    const text = document.querySelector('[data-component="ProductOverviewAnimation_Text_Purple"]');
    text.style.opacity = "0";
}

// Yellow Dot

/**
 * @return {boolean}
 */
function ProductOverviewAnimation_Dot_Yellow_isActive() {
    const rect = document.querySelector('[data-component="ProductOverviewAnimation"]').getBoundingClientRect();
    return rect.y < window.innerHeight * 0.8;
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Yellow_play_fadeIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Yellow"]').classList.remove('product-overview-animation-dot-invisible');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Yellow_play_bounceIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Yellow"]').classList.add('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Yellow_play_colorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Yellow"]').classList.remove('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Yellow_play_reveal() {
    ProductOverviewAnimation_Dot_Yellow_play_bounceIn();
    ProductOverviewAnimation_Dot_Yellow_play_colorize();
}

// Red Dot

/**
 * @return {boolean}
 */
function ProductOverviewAnimation_Dot_Red_isActive() {
    const rect = document.querySelector('[data-component="ProductOverviewAnimation_Text_Red"]').getBoundingClientRect();
    return rect.y < window.innerHeight * 0.5;
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_fadeIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Red"]').classList.remove('product-overview-animation-dot-invisible');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_bounceIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Red"]').classList.add('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_colorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Red"]').classList.remove('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_reveal() {
    ProductOverviewAnimation_Dot_Red_play_bounceIn();
    ProductOverviewAnimation_Dot_Red_play_colorize();
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_bounceOut() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Red"]').classList.remove('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_decolorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Red"]').classList.add('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Red_play_hide() {
    ProductOverviewAnimation_Dot_Red_play_bounceOut();
    ProductOverviewAnimation_Dot_Red_play_decolorize();
}

// Blue Dot

/**
 * @return {boolean}
 */
function ProductOverviewAnimation_Dot_Blue_isActive() {
    const rect = document.querySelector('[data-component="ProductOverviewAnimation_Text_Blue"]').getBoundingClientRect();
    return rect.y < window.innerHeight * 0.5;
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_fadeIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Blue"]').classList.remove('product-overview-animation-dot-invisible');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_bounceIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Blue"]').classList.add('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_colorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Blue"]').classList.remove('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_reveal() {
    ProductOverviewAnimation_Dot_Blue_play_bounceIn();
    ProductOverviewAnimation_Dot_Blue_play_colorize();
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_bounceOut() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Blue"]').classList.remove('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_decolorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Blue"]').classList.add('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Blue_play_hide() {
    ProductOverviewAnimation_Dot_Blue_play_bounceOut();
    ProductOverviewAnimation_Dot_Blue_play_decolorize();
}

// Purple Dot

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_fadeIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Purple"]').classList.remove('product-overview-animation-dot-invisible');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_bounceIn() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Purple"]').classList.add('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_colorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Purple"]').classList.remove('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_reveal() {
    ProductOverviewAnimation_Dot_Purple_play_bounceIn();
    ProductOverviewAnimation_Dot_Purple_play_colorize();
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_bounceOut() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Purple"]').classList.remove('product-overview-animation-bounce-in');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_decolorize() {
    document.querySelector('[data-component="ProductOverviewAnimation_Dot_Purple"]').classList.add('product-overview-animation-dot-colorless');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_Dot_Purple_play_hide() {
    ProductOverviewAnimation_Dot_Purple_play_bounceOut();
    ProductOverviewAnimation_Dot_Purple_play_decolorize();
}

// Encounter animation

/**
 * @return {void}
 */
function ProductOverviewAnimation_play_init() {
    ProductOverviewAnimation_Background_play();
    ProductOverviewAnimation_Center_play();

    window.setTimeout(() => {
        ProductOverviewAnimation_Dot_Yellow_play_fadeIn();
        ProductOverviewAnimation_Dot_Yellow_play_reveal();
    }, 400);

    window.setTimeout(() => ProductOverviewAnimation_Dot_Red_play_fadeIn(), 600);
    window.setTimeout(() => ProductOverviewAnimation_Dot_Blue_play_fadeIn(), 800);
    window.setTimeout(() => ProductOverviewAnimation_Dot_Purple_play_fadeIn(), 1000);
}

/**
 * @return {boolean}
 */
function ProductOverviewAnimation_Dot_Purple_isActive() {
    const rect = document.querySelector('[data-component="ProductOverviewAnimation_Text_Purple"]').getBoundingClientRect();
    return rect.y < window.innerHeight * 0.5;
}

/**
 * @param hash - Hash needs to include '#' prefix.
 * @return {void}
 */
function Window_setUrlHash(hash) {
    const url = window.location.href.split('#')[0];
    window.history.replaceState(null, '', url + hash)
}

/**
 * @param ev {MouseEvent}
 * @return {void}
 */
function When_ProductOverviewAnimation_Tab_Anchor_clicked(ev) {
    if (ev.currentTarget instanceof HTMLAnchorElement) {
        const a = ev.currentTarget;

        ev.preventDefault();

        document.querySelector(a.hash).scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

        Window_setUrlHash(a.hash);
    }
}

/**
 * @return {boolean}
 */
function ProductOverviewAnimation_isOnPage() {
    return !!document.querySelector('[data-component="ProductOverviewAnimation"]');
}

/**
 * @return {void}
 */
function ProductOverviewAnimation_init() {
    if (ProductOverviewAnimation_isOnPage()) {
        setInterval(() => {
            if (window.innerWidth < 1190) {
                ProductOverviewAnimation_Text_Yellow_activate();
                ProductOverviewAnimation_Text_Red_activate();
                ProductOverviewAnimation_Text_Blue_activate();
                ProductOverviewAnimation_Text_Purple_activate();
                return;
            }

            let step = "Yellow";

            if (ProductOverviewAnimation_Dot_Yellow_isActive()) {
                ProductOverviewAnimation_play_init();
            }

            if (ProductOverviewAnimation_Dot_Red_isActive()) {
                step = "Red";
                ProductOverviewAnimation_Dot_Red_play_reveal();
                ProductOverviewAnimation_Text_Red_activate();
            } else {
                ProductOverviewAnimation_Dot_Red_play_hide();
            }

            if (ProductOverviewAnimation_Dot_Blue_isActive()) {
                step = "Blue";
                ProductOverviewAnimation_Dot_Blue_play_reveal();
            } else {
                ProductOverviewAnimation_Dot_Blue_play_hide();
            }

            if (ProductOverviewAnimation_Dot_Purple_isActive()) {
                step = "Purple";
                ProductOverviewAnimation_Dot_Purple_play_reveal();
            } else {
                ProductOverviewAnimation_Dot_Purple_play_hide();
            }

            if (step === "Red") {
                ProductOverviewAnimation_Text_Yellow_deactivate();
                ProductOverviewAnimation_Text_Red_activate();
                ProductOverviewAnimation_Text_Blue_deactivate();
                ProductOverviewAnimation_Text_Purple_deactivate();
            } else if (step === "Blue") {
                ProductOverviewAnimation_Text_Yellow_deactivate();
                ProductOverviewAnimation_Text_Red_deactivate();
                ProductOverviewAnimation_Text_Blue_activate();
                ProductOverviewAnimation_Text_Purple_deactivate();
            } else if (step === "Purple") {
                ProductOverviewAnimation_Text_Yellow_deactivate();
                ProductOverviewAnimation_Text_Red_deactivate();
                ProductOverviewAnimation_Text_Blue_deactivate();
                ProductOverviewAnimation_Text_Purple_activate();
            } else {
                ProductOverviewAnimation_Text_Yellow_activate();
                ProductOverviewAnimation_Text_Red_deactivate();
                ProductOverviewAnimation_Text_Blue_deactivate();
                ProductOverviewAnimation_Text_Purple_deactivate();
            }
        }, 200);

        document.querySelectorAll('[data-component="ProductOverviewAnimation_Tab_Anchor"]').forEach(a => {
            a.addEventListener("click", When_ProductOverviewAnimation_Tab_Anchor_clicked);
        });
    }
}

/**
 * PageProduct
 */

/**
 * @return {void}
 */
function PageProduct_init() {
    HeroAnimation_init();
    ProductOverviewAnimation_init();
}

module.exports = {
    init: PageProduct_init,
};